import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { SharedModule } from '../../shared';
import { ROUTES } from './property.routes';
import { DxTabPanelModule } from 'devextreme-angular/ui/tab-panel';
import {
  AddPropertyDetailsComponent, AddPropertyFinancialsComponent, PropertyDetailsEditComponent, ReserveStudyEditComponent,
  PropertyFinancialsComponent,
} from './components';
import {
  PropertyDetailsComponent,
  AddPropertyComponent
} from './pages';
import { services } from './shared/services';
import { ModalModule } from 'ngx-bootstrap/modal';
import { CommonModule } from '@angular/common';
import { InternalSharedModule } from '../shared';
import { EffectsModule } from '@ngrx/effects';
import { PropertyEffects } from './property-store/property.effects';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxButtonModule } from 'devextreme-angular/ui/button';
import { DxFileUploaderModule } from 'devextreme-angular/ui/file-uploader';
import { ConnectedAppsModule } from '../connected-apps';
import { ActivityModule } from '../activity';

const PROVIDERS = [
  ...services
];

@NgModule({
  declarations: [
    /* Pages */
    PropertyDetailsComponent,
    /* Components */
    PropertyDetailsEditComponent,
    ReserveStudyEditComponent,
    PropertyFinancialsComponent,
    AddPropertyDetailsComponent,
    AddPropertyComponent,
    AddPropertyFinancialsComponent
  ],
  exports: [
    AddPropertyDetailsComponent,
    AddPropertyComponent,
    AddPropertyFinancialsComponent,
    PropertyDetailsEditComponent,
    ReserveStudyEditComponent,
  ],
  imports: [
    ActivityModule,
    ConnectedAppsModule,
    CommonModule,
    EffectsModule.forFeature([PropertyEffects]),
    FormsModule,
    InternalSharedModule,
    ModalModule,
    ReactiveFormsModule,
    RouterModule.forChild(ROUTES),
    SharedModule,
    DxDataGridModule,
    DxButtonModule,
    DxFileUploaderModule,
    DxTabPanelModule],
  providers: [
    PROVIDERS,
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class PropertyModule {
}
